import { OfferedReplyDraft } from './OfferedReplyDraft';
import { useLentComposer } from '../../state/composerBridge';

import { Modal, ModalBackdrop, ModalContent } from '@/components/ui/modal';

export type ReplyDraftModalProps = {
  isOpen: boolean;
  conversationId: string;
  onClose: () => void;
};

/**
 * The reply draft on web: a large modal over the chat, as the reference
 * assistant is on web, at most the viewport's height, with only its body
 * scrolling. Escape and the backdrop close it, and closing loses nothing
 * because the draft lives on the server.
 */
export function ReplyDraftModal({ isOpen, conversationId, onClose }: ReplyDraftModalProps) {
  const composer = useLentComposer(conversationId);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalBackdrop />

      <ModalContent className="h-[90vh] max-h-[90vh] p-0">
        {isOpen && composer ? (
          <OfferedReplyDraft
            conversationId={conversationId}
            composer={composer}
            onClose={onClose}
          />
        ) : null}
      </ModalContent>
    </Modal>
  );
}
